module.exports = __webpack_public_path__ + "img/seabrokers-group-logo.252a6bc3.png";